import axios from 'axios';
import { getToken, hasToken } from '@/common/token';
import store from '@/store/store';
import omit from 'lodash/omit';

const service = axios.create({
	baseURL: 'https://api.jpworldpay.com/api/v1',
	timeout: 600000,
	withCredentials: true,
});

export const getHeaders = () => {
	const headers = {};
	const token = getToken();

	headers['Accept-Language'] = store.state.common.locale;

	if (hasToken()) {
		headers.Authorization = `Bearer ${token}`;
	}

	return headers;
};

service.interceptors.request.use(
	config => {
		store.commit('common/SET_IS_LOADING', true);
		config.headers = { ...config.headers, ...getHeaders() };

		return config;
	},
	error => {
		store.commit('common/SET_IS_LOADING', false);
		return Promise.reject(error);
	},
);

service.interceptors.response.use(
	response => {
		store.commit('common/SET_IS_LOADING', false);
		const res = response.data;
		return { ...omit(res, 'variable'), ...res.variables };
	},
	error => {
		let result = null;
		if (error.response && error.response.data) {
			result = {
				...omit(error.response.data, 'variable'),
				...error.response.data.variables,
			};
		} else {
			result = {
				error: -1,
				message: error.message,
				httpStatusCode: error.response ? error.response.status : null,
			};
		}
		store.commit('common/SET_IS_LOADING', false);
		return Promise.reject(result);
	},
);

export default service;
